import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SuccessAlert from "./../child/Alert/SuccessAlert";
import DengerAlert from "./../child/Alert/DengerAlert";
import Loader from "./../child/Loder";

const ViewChatPaymentNew = () => {
  const [successMessage, setSuccessMessage] = useState(""); // Manage Success Message
  const [errorMessage, setErrorMessage] = useState(""); // Manage Error Message
  const [ItemData, setItemData] = useState([]);
  const [RenterName, setRenterName] = useState("");
  const [HostName, setHostName] = useState("");
  const [loading, setLoading] = useState(true); // State to handle loading
  const { id } = useParams();
  const isEditMode = !!id;
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) return; // Ensure id is defined before making the request

    const fetchAdminData = async () => {
      const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/chat-transaction-detail-admin/${id}`;
      try {
        setLoading(true);
        const authToken = localStorage.getItem("authToken");
        const response = await fetch(API_ENDPOINT, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch transaction data");
        }

        const datas = await response.json();

        setItemData(datas.data);
        setHostName(datas.data.hostDetails?.name || "");
        setRenterName(datas.data.renterDetails?.name || "");
      } catch (err) {
        setErrorMessage(err.message);
        setTimeout(() => {
          setErrorMessage("");
        }, 3000);
      } finally {
        setLoading(false);
      }
    };

    fetchAdminData();
  }, [isEditMode, id]);
  if (loading) return <Loader />;
  return (
    <div className="row gy-4">
      <div className="col-lg-4">
        {successMessage && (
          <SuccessAlert
            message={successMessage}
            onClose={() => setSuccessMessage("")}
          />
        )}
        {errorMessage && (
          <DengerAlert
            message={errorMessage}
            onClose={() => setErrorMessage("")}
          />
        )}
      </div>

      <div className="col-md-12">
        <div className="card h-100">
          <div className="card-body p-24">
            <div className="row">
              <strong>
                <u>Payment Detail:-</u>
              </strong>

              <div className="col-md-3">
                <span>
                  <b>Transaction Id: </b>
                </span>{" "}
                {ItemData?.transactionId}
              </div>
              <div className="col-md-3">
                <span>
                  <b>Amount($):</b>{" "}
                </span>{" "}
                {ItemData?.amount}
              </div>
              <div className="col-md-3">
                <span>
                  <b>Payment Status:</b>{" "}
                </span>{" "}
                {ItemData?.paymentStatus}
              </div>
              <div className="col-md-3">
                <span>
                  <b>Payment Method:</b>{" "}
                </span>{" "}
                {ItemData?.paymentMethod}
              </div>

              <div
                className="col-md-3"
                style={{ display: "flex", marginTop: "10px" }}
              >
                <span>
                  <b>Payment Date:</b>&nbsp;{" "}
                </span>
                <p>
                  {ItemData?.transactionDate
                    ? (() => {
                        const date = new Date(ItemData.transactionDate);
                        const day = String(date.getDate()).padStart(2, "0");
                        const month = String(date.getMonth() + 1).padStart(
                          2,
                          "0"
                        );
                        const year = String(date.getFullYear());
                        return `${day}-${month}-${year}`;
                      })()
                    : "N/A"}
                </p>
              </div>

              <div
                className="col-md-3"
                style={{ display: "flex", marginTop: "10px" }}
              >
                <span>
                  <b>Start Date:</b>&nbsp;
                </span>
                <p>
                  {ItemData?.startDate
                    ? (() => {
                        const date = new Date(ItemData.startDate);
                        const day = String(date.getDate()).padStart(2, "0");
                        const month = String(date.getMonth() + 1).padStart(
                          2,
                          "0"
                        );
                        const year = String(date.getFullYear());
                        return `${day}-${month}-${year}`;
                      })()
                    : "N/A"}
                </p>
              </div>

              <div
                className="col-md-3"
                style={{ display: "flex", marginTop: "10px" }}
              >
                <span>
                  <b>End Date:</b> &nbsp;
                </span>
                <p>
                  {ItemData?.endDate
                    ? (() => {
                        const date = new Date(ItemData.endDate);
                        const day = String(date.getDate()).padStart(2, "0");
                        const month = String(date.getMonth() + 1).padStart(
                          2,
                          "0"
                        );
                        const year = String(date.getFullYear());
                        return `${day}-${month}-${year}`;
                      })()
                    : "N/A"}
                </p>
              </div>
            </div>

            <div className="row">
              <strong>
                <u>Storage Space Detail:-</u>
              </strong>

              <div className="col-md-3" style={{ marginTop: "10px" }}>
                <span>
                  <b>Address:</b>{" "}
                </span>{" "}
                {ItemData?.storageSpace?.address}
              </div>
              <div className="col-md-3">
                <span>
                  <b>Renter name:</b>{" "}
                </span>{" "}
                {ItemData?.renterDetails?.name}
              </div>
              <div className="col-md-3">
                <span>
                  <b>Renter email:</b>{" "}
                </span>{" "}
                {ItemData?.renterDetails?.email}
              </div>
              <div className="col-md-3">
                <span>
                  <b>Host name:</b>{" "}
                </span>{" "}
                {ItemData?.hostDetails?.name}
              </div>
              <div className="col-md-3" style={{ marginTop: "10px" }}>
                <span>
                  <b>Host email:</b>{" "}
                </span>{" "}
                {ItemData?.hostDetails?.email}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewChatPaymentNew;
